<template>
  <LearnStep/>
</template>

<script>
    import LearnStep from '../components/main/learn/LearnStep';

    export default {
        name: 'Learn',
        components:{
            LearnStep
        },
    }
</script>

<style lang="scss" scoped>
  
</style>

